'use client';

import { useState } from 'react';

// Generic button wrapping an async onClick: disables itself and shows a spinner while pending, preventing double-submits.
export default function Button({ onClick, children, className = '', disabled = false, type = 'button', ...props }) {
  const [pending, setPending] = useState(false);

  const handleClick = async (e) => {
    if (pending || disabled) return;
    setPending(true);
    try {
      await onClick?.(e);
    } finally {
      setPending(false);
    }
  };

  return (
    <button
      type={type}
      disabled={disabled || pending}
      onClick={handleClick}
      className={`inline-flex items-center justify-center gap-2 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      {...props}
    >
      {pending && (
        <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {children}
    </button>
  );
}
